import * as ng from 'angular';
import * as xml2js from 'xml2js';
import {ArchiSmallServices} from '../../../../../services/archismall.service';
import {DateService} from '../../../../../services/date.service';
import {LogoService} from '../../../../../services/logo.service';
import {CassaService} from '../../../../../services/data/cassa.service';
import {VATService} from '../../../../../services/data/vat.service';
import {AlertService} from '../../../../../services/ui/alert.service';
import {FormService} from '../../../../../services/ui/form.service';
import {NumbersService} from '../../../../../services/ui/numbers.service';
import {appContext} from '../../../../../app.context';
import {
  IAllegati,
  IAnagrafica,
  ICedentePrestatore,
  ICessionarioCommittente,
  IDatiPagamento,
  IFattura
} from '../../../../../commons/interfaces/invoices/fattura';
import {IUser} from '../../../../../commons/interfaces/user/user';

// @ts-nocheck

export const PAComponiFatturaSempliceComponent = {
  template: require('./pa-componi-fattura-semplice.html'),
  controller: class PAComponiFatturaSempliceComponent {

    static $inject: string[] = [
      '$scope',
      '$rootScope',
      '$state',
      '$stateParams',
      'store',
      'ArchiSmallServices',
      'DateService',
      'LogoService',
      'CassaService',
      'VATService',
      'AlertService',
      'FormService',
      'NumbersService',
      '$timeout',
      '$uibModal'
    ];

    private tooltips: Record<string, string>;

    private imagePreview: string;

    constructor(
      private $scope: {
        FatturaPA: IFattura;
        [key: string]: any;
      },
      private $rootScope: any,
      private $state: ng.ui.IStateService,
      private $stateParams: ng.ui.IStateParamsService,
      private store: ng.a0.storage.IStoreService,
      private ArchiSmallServices: ArchiSmallServices,
      private dateService: DateService,
      private logoService: LogoService,
      private cassaService: CassaService,
      private vatService: VATService,
      private alertService: AlertService,
      private formService: FormService,
      private numbersService: NumbersService,
      private $timeout: ng.ITimeoutService,
      private $uibModal: ng.ui.bootstrap.IModalService
    ) {
      let isAutofattura = false;

      /* tslint:disable:no-string-literal */
      this.tooltips = {
        'avanzata': 'Sei un utente esperto di Fatturazione Elettronica o hai esigenze particolari?\n' +
          'Utilizza la forma Avanzata per trovare ulteriori campi.',
        'cigCup': 'Aggiungere una sezione CIG/CUP.\nLeggi gli aiuti all\'interno per saperne di più.',
        'casaPrevidenziale': 'Aggiungere una sezione Cassa previdenziale.\nLeggi gli aiuti all\'interno per saperne di più.',
        'ritenutaAcconto': 'Aggiungere una sezione Ritenuta d\'acconto.\nLeggi gli aiuti all\'interno per saperne di più.',
        'scissionePagamenti': 'Se selezioni Scissione Pagamenti significa che la\nPA destinataria opta per lo Split Payment' +
          ' e di conseguenza\nl\'imposta verrà versata direttamente all\'Erario.\nRicorda di verificare con la PA destinataria se opta per lo Split Payment.',
        'bolloVirtuale': 'Aggiungere una sezione Bollo Virtuale.\nLeggi gli aiuti all\'interno per saperne di più.'
      };

      $scope.today = {
        maxDate: new Date(),
      };

      let DettaglioLineeItem = {
        NumeroLinea: 0,
        TipoCessionePrestazione: '',
        CodiceArticolo: [],
        Descrizione: '',
        Quantita: '0.00',
        UnitaMisura: '',
        DataInizioPeriodo: '',
        DataFinePeriodo: '',
        PrezzoUnitario: '0.00',
        ScontoMaggiorazione: [],
        PrezzoTotale: '0.00',
        AliquotaIVA: '22.00',
        Ritenuta: '',
        Natura: '',
        RiferimentoAmministrazione: '',
        AltriDatiGestionali: [],
        IVA: '3'// fake fielf used for Iva Management
      };
      let DatiRiepilogoItem = {
        AliquotaIVA: '0.00',
        Natura: '',
        ImponibileImporto: '0.00',
        Imposta: '0.00',
        EsigibilitaIVA: '',
        RiferimentoNormativo: ''
      };
      let DettaglioPagamentoItem = {
        Beneficiario: '',
        ModalitaPagamento: 'MP05',
        DataRiferimentoTerminiPagamento: '',
        GiorniTerminiPagamento: '',
        DataScadenzaPagamento: '',
        ImportoPagamento: '0.00',
        CodUfficioPostale: '',
        CognomeQuietanzante: '',
        NomeQuietanzante: '',
        CFQuietanzante: '',
        TitoloQuietanzante: '',
        IstitutoFinanziario: '',
        IBAN: '',
        ABI: '',
        CAB: '',
        BIC: '',
        DataLimitePagamentoAnticipato: '',
        DataDecorrenzaPenale: '',
        CodicePagamento: ''
      };
      let DatiPagamentoItem = {
        CondizioniPagamento: 'TP02',
        DettaglioPagamento: []
      } as IDatiPagamento;
      let AllegatiItem = {
        NomeAttachment: '',
        AlgoritmoCompressione: '',
        FormatoAttachment: '',
        DescrizioneAttachment: '',
        Attachment: ''
      } as IAllegati;
      let DatiBolloItem = {
        BolloVirtuale: undefined,
        ImportoBollo: '0.00'
      };
      let FatturaElettronicaBodyItem = {
        DatiGenerali: {
          DatiGeneraliDocumento: {
            TipoDocumento: 'TD01',
            Divisa: '',
            Data: '',
            Numero: '',
            DatiRitenuta: [],
            DatiBollo: undefined,
            DatiCassaPrevidenziale: [],
            ScontoMaggiorazione: [],
            ImportoTotaleDocumento: '0.00',
            Arrotondamento: '0.00',
            Causale: [],
            Art73: ''
          },
          DatiOrdineAcquisto: [],
          DatiContratto: [],
          DatiConvenzione: [],
          DatiRicezione: [],
          DatiFattureCollegate: [],
          DatiSAL: [],
          DatiDDT: [],
          DatiTrasporto: {},
          FatturaPrincipale: {}
        },
        DatiBeniServizi: {
          DettaglioLinee: [],
          DatiRiepilogo: []
        },
        DatiVeicoli: {},
        DatiPagamento: [],
        Allegati: []
      };
      let FatturaPA = {
        FatturaPA: {
          FatturaElettronicaHeader: {
            DatiTrasmissione: {
              IdTrasmittente: {
                IdPaese: 'IT',
                IdCodice: '02576660365'
              },
              ProgressivoInvio: '',
              FormatoTrasmissione: 'FPA12',
              CodiceDestinatario: '',
              ContattiTrasmittente: {
                Telefono: '059330959',
                Email: 'helpdesk@archismall.com'
              }
            },
            CedentePrestatore: {
              DatiAnagrafici: {
                IdFiscaleIVA: {
                  IdPaese: '',
                  IdCodice: ''
                },
                CodiceFiscale: '',
                Anagrafica: {
                  Denominazione: '',
                  Titolo: '',
                  CodEORI: ''
                },
                AlboProfessionale: '',
                ProvinciaAlbo: '',
                NumeroIscrizioneAlbo: '',
                DataIscrizioneAlbo: '',
                RegimeFiscale: ''
              },
              Sede: {
                Indirizzo: '',
                NumeroCivico: '',
                CAP: '',
                Comune: '',
                Provincia: '',
                Nazione: ''
              },
              StabileOrganizzazione: {},
              IscrizioneREA: {},
              Contatti: {},
              RiferimentoAmministrazione: ''
            },
            RappresentanteFiscale: {},
            CessionarioCommittente: {
              DatiAnagrafici: {
                IdFiscaleIVA: {},
                CodiceFiscale: '',
                Anagrafica: {
                  Denominazione: '',
                  Titolo: '',
                  CodEORI: ''
                }
              },
              Sede: {
                Indirizzo: '',
                NumeroCivico: '',
                CAP: '',
                Comune: '',
                Provincia: '',
                Nazione: ''
              }
            },
            SoggettoEmittente: ''
          },
          FatturaElettronicaBody: []
        } as IFattura
      };

      $scope.esigibilitaItems = [
        {
          'data-id': 'S',
          'label': 'Scissione Pagamenti'
        },
        {
          'data-id': 'I',
          'label': 'Immediata'
        },
        {
          'data-id': 'D',
          'label': 'Differita'
        }
      ];

      $scope.TipoDocumentoType = {
        'TD01': 'TD01 - Fattura',
        'TD02': 'TD02 - Acconto / anticipo su fattura',
        'TD03': 'TD03 - Acconto / anticipo su parcella',
        'TD04': 'TD04 - Nota di credito',
        'TD05': 'TD05 - Nota di debito',
        'TD06': 'TD06 - Parcella',
        'TD16': 'TD16 - Integrazione fattura reverse charge interno',
        'TD17': 'TD17 - Integrazione/autofattura per acquisto servizi dall\'estero',
        'TD18': 'TD18 - Integrazione per acquisto di beni intracomunitari',
        'TD19': 'TD19 - Integrazione/autofattura per acquisto di beni ex art.17 c.2 DPR 633/72',
        'TD20': 'TD20 - Autofattura per regolarizzazione e integrazione delle fatture (ex art. 6 c.9-bis d.lgs. 471/97 o art.46 c.5 D.L. 331/93)',
        'TD21': 'TD21 - Autofattura per splafonamento',
        'TD22': 'TD22 - Estrazione benida Deposito IVA',
        'TD23': 'TD23 - Estrazione beni da Deposito IVA con versamento dell\'IVA',
        'TD24': 'TD24 - Fattura differita di cui all\'art.21, comma 4, terzo periodo lett. a) DPR 633/72',
        'TD25': 'TD25 - FFattura differita di cui all\'art.21, comma 4, terzo periodo lett. b) DPR 633/72',
        'TD26': 'TD26 - Cessione di beni ammortizzabili e per passaggi interni (ex art.36 DPR 633/72)',
        'TD27': 'TD27 - Fattura per autoconsumo o per cessioni gratuite senza rivalsa',
        'TD28': 'TD28 - Acquisti da San Marino con IVA (fattura cartacea)',
        'TD29': 'TD29 - Comunicazione per omessa o irregolare fatturazione da parte del cedente/prestatore italiano (art. 6, comma 8, D.Lgs. 471/97)'
      };

      $scope.CondizioniPagamentoType = {
        'TP01': 'Pagamento a rate',
        'TP02': 'Pagamento completo',
        'TP03': 'Anticipo'
      };

      $scope.TipoCassaType = this.cassaService.getItems();
      $scope.ivaItems = this.vatService.getItems();

      $scope.pagamentoOptions = {
        '1': 'Pagamento con bonifico',
        '2': 'Pagamento con contanti'
      };

      $scope.dynamicItem = {
        'CodiceCIG': '',
        'CodiceCUP': '',
        'TipoDocumento': '',
        'IdDocumento': ''
      };

      $scope.TipoRitenutaType = {
        'RT01': 'RT01 - Ritenuta di acconto persone fisiche',
        'RT02': 'RT02 - Ritenuta di acconto persone giuridiche',
        'RT03': 'RT03 - Contributo INPS',
        'RT04': 'RT04 - Contributo ENASARCO',
        'RT05': 'RT05 - Contributo ENPAM',
        'RT06': 'RT06 - Altro contributo previdenziale'
      };

      $scope.CausalePagamentoType = {
        'A': 'A - Prestazioni di lavoro autonomo rientranti nell’esercizio di arte o professione abituale',
        'B': 'B - Utilizzazione economica, da parte dell’autore o dell’inventore, di opere dell’ingegno, di brevetti industriali e di processi, formule o informazioni relativi a esperienze acquisite in campo industriale, commerciale o scientifico',
        'C': 'C - Utili derivanti da contratti di associazione in partecipazione e da contratti di cointeressenza, quando l’apporto è costituito esclusivamente dalla prestazione di lavoro',
        'D': 'D - Utili spettanti ai soci promotori e ai soci fondatori delle società di capitali',
        'E': 'E - Levata di protesti cambiari da parte dei segretari comunali',
        'G': 'G - Indennità corrisposte per la cessazione di attività sportiva professionale',
        'H': 'H - Indennità corrisposte per la cessazione dei rapporti di agenzia delle persone fisiche e delle società di persone, con esclusione delle somme maturate entro il 31.12.2003, già imputate per competenza e tassate come reddito d’impresa',
        'I': 'I - Indennità corrisposte per la cessazione da funzioni notarili',
        'L': 'L - Utilizzazione economica, da parte di soggetto diverso dall’autore o dall’inventore, di opere dell’ingegno, di brevetti industriali e di processi, formule e informazioni relative a esperienze acquisite in campo industriale, commerciale o scientifico',
        'M': 'M - Prestazioni di lavoro autonomo non esercitate abitualmente, obblighi di fare, di non fare o permettere',
        'N': 'N - Indennità di trasferta, rimborso forfetario di spese, premi e compensi erogati : .. nell’esercizio diretto di attività sportive dilettantistiche',
        'O': 'O - Prestazioni di lavoro autonomo non esercitate abitualmente, obblighi di fare, di non fare o permettere, per le quali non sussiste l’obbligo di iscrizione alla gestione separata (Circ. Inps 104/2001)',
        'P': 'P - Compensi corrisposti a soggetti non residenti privi di stabile organizzazione per l’uso o la concessione in uso di attrezzature industriali, commerciali o scientifiche che si trovano nel territorio dello',
        'Q': 'Q - Provvigioni corrisposte ad agente o rappresentante di commercio monomandatario',
        'R': 'R - Provvigioni corrisposte ad agente o rappresentante di commercio plurimandatario',
        'S': 'S - Provvigioni corrisposte a commissionario',
        'T': 'T - Provvigioni corrisposte a mediatore',
        'U': 'U - Provvigioni corrisposte a procacciatore di affari',
        'V': 'V - Provvigioni corrisposte a incaricato per le vendite a domicilio e provvigioni corrisposte a incaricato per la vendita porta a porta e per la vendita ambulante di giornali quotidiani e periodici (L. 25.02.1987, n. 67)',
        'W': 'W - Corrispettivi erogati nel 2013 per prestazioni relative a contratti d’appalto cui si sono resi applicabili le disposizioni contenute nell’art. 25-ter D.P.R. 600/1973',
        'X': 'X - Canoni corrisposti nel 2004 da società o enti residenti, ovvero da stabili organizzazioni di società estere di cui all’art. 26-quater, c. 1, lett. a) e b) D.P.R. 600/1973, a società o stabili organizzazioni di società, situate in altro Stato membro dell’Unione Europea in presenza dei relativi requisiti richiesti, per i quali è stato effettuato nel 2006 il rimborso della ritenuta ai sensi dell’art. 4 D. Lgs. 143/2005',
        'Y': 'Y - Canoni corrisposti dal 1.01.2005 al 26.07.2005 da soggetti di cui al punto precedente',
        'ZO': 'ZO - Titolo diverso dai precedenti',
        'L1': 'L1 - Redditi derivanti dall’utilizzazione economica di opere dell’ingegno, di brevetti industriali e di processi, che sono percepiti da soggetti che abbiano acquistato a titolo oneroso i diritti alla loro utilizzazione.',
        'M1': 'M1 - Redditi derivanti dall’assunzione di obblighi di fare, di non fare o permettere.',
        'M2': 'M2 - Prestazioni di lavoro autonomo non esercitate abitualmente per le quali sussiste l’obbligo di iscrizione alla Gestione Separata ENPAPI.',
        'O1': 'O1 - Redditi derivanti dall’assunzione di obblighi di fare, di non fare o permettere, per le quali non sussiste l’obbligo di iscrizione alla gestione separata (Circ. INPS n. 104/2001).',
        'V1': 'V1 - Redditi derivanti da attività commerciali non esercitate abitualmente (ad esempio, provvigioni corrisposte per prestazioni occasionali ad agente o rappresentante di commercio, mediatore, procacciatore d’affari);',
      };

      $scope.String1000LatinType = new RegExp('^[\u0000-\u00FF]{1,1000}$');
      $scope.IBANType = new RegExp('^[a-zA-Z]{2}[0-9]{2}[a-zA-Z0-9]{23,30}$');
      $scope.String15Type = new RegExp('^[\u0000-\u007F]{1,15}$');
      $scope.String20Type = new RegExp('^[\u0000-\u007F]{1,20}$');
      $scope.String200LatinType = new RegExp('^[\u0000-\u00FF]{1,200}$');
      $scope.IdentificativoSdIType = new RegExp('^[0-9]{1,36}$');

      $scope.hasRitenutaImportoContributoCassa = false;
      $scope.hasRitenutaEnasarcoInCassaPrevidenziale = false;

      let getDataFromUser = () => {
        ArchiSmallServices.getUser($rootScope.currentUser().sub)
          .then((response) => {
            const res = JSON.parse(JSON.stringify(response)) as IUser;
            $rootScope.user = JSON.parse(JSON.stringify(response)) as IUser;
            store.set('user', response);
            DettaglioLineeItem.IVA = res.organizationData.ivaDefault;
            // @ts-ignore
            $scope.FatturaPA.FatturaElettronicaBody[0].DatiBeniServizi.DettaglioLinee[0].IVA = DettaglioLineeItem.IVA;
            let userOrganizationData = (jQuery.extend(true, {}, res.organizationData));
            // datiAnagrafici
            $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.IdFiscaleIVA.IdCodice = userOrganizationData.PIVA;
            $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.IdFiscaleIVA.IdPaese = userOrganizationData.codicePaese;
            if (userOrganizationData.fiscalCode) {
              $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.CodiceFiscale = userOrganizationData.fiscalCode;
            }
            if (res.accountData.userType === 1) {
              $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.Anagrafica.Nome = userOrganizationData.contactPerson.firstname;
              $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.Anagrafica.Cognome = userOrganizationData.contactPerson.surname;
            } else {
              $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.Anagrafica.Denominazione = userOrganizationData.name;
            }

            $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.Anagrafica.Titolo = userOrganizationData.titolo;
            $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.Anagrafica.CodEORI = userOrganizationData.codEORI;
            // sede
            $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.Sede.Indirizzo = userOrganizationData.address;
            if (userOrganizationData.numeroCivico) {
              $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.Sede.NumeroCivico = userOrganizationData.numeroCivico;
            }
            $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.Sede.CAP = userOrganizationData.CAP;
            $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.Sede.Comune = userOrganizationData.city;
            if (userOrganizationData.provinceCode) {
              $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.Sede.Provincia = userOrganizationData.provinceCode;
            }
            $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.Sede.Nazione = userOrganizationData.codicePaese;
            // end sede

            $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.Contatti.Telefono = userOrganizationData.phoneNumber || userOrganizationData.mobilePhoneNumber;
            $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.Contatti.Email = res.accountData.emailNotifications || res.accountData.email;

            if (userOrganizationData.fax) {
              $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.Contatti.Fax = userOrganizationData.fax;
            }

            if (userOrganizationData.stabileOrganizzazioneAddressIsDifferent && userOrganizationData.stabileOrganizzazione) {
              $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.StabileOrganizzazione.CAP = userOrganizationData.stabileOrganizzazione.CAP;
              $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.StabileOrganizzazione.Comune = userOrganizationData.stabileOrganizzazione.city;
              $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.StabileOrganizzazione.Indirizzo = userOrganizationData.stabileOrganizzazione.address;
              $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.StabileOrganizzazione.Nazione = userOrganizationData.stabileOrganizzazione.codicePaese;
              if (userOrganizationData.stabileOrganizzazione.numeroCivico) {
                $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.StabileOrganizzazione.NumeroCivico = userOrganizationData.stabileOrganizzazione.numeroCivico;
              }
              if (userOrganizationData.stabileOrganizzazione.provinceCode) {
                $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.StabileOrganizzazione.Provincia = userOrganizationData.stabileOrganizzazione.provinceCode;
              }
              // user.getOrganizationData().getStabileOrganizzazione().getAdditionalProperties().get("provinceCode")
            }

            if (userOrganizationData.inscrizioneREAIncluded && userOrganizationData.inscrizioneREA) {
              if (userOrganizationData.inscrizioneREA.capitaleSociale) {
                $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.IscrizioneREA.CapitaleSociale = this.numbersService.formatDecimal(userOrganizationData.inscrizioneREA.capitaleSociale, 2);
              }
              $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.IscrizioneREA.NumeroREA = userOrganizationData.inscrizioneREA.numeroREA;
              // @ts-ignore
              $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.IscrizioneREA.SocioUnico = userOrganizationData.inscrizioneREA.socioUnico;
              // @ts-ignore
              $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.IscrizioneREA.StatoLiquidazione = userOrganizationData.inscrizioneREA.statoLiquidazione;
              $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.IscrizioneREA.Ufficio = userOrganizationData.inscrizioneREA.ufficio;
            }

            if (userOrganizationData.alboProfessionaleIncluded && userOrganizationData.alboProfessionale) {
              if (userOrganizationData.alboProfessionale.alboProfessionale) {
                $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.AlboProfessionale = userOrganizationData.alboProfessionale.alboProfessionale;
              }
              if (userOrganizationData.alboProfessionale.dataIscrizioneAlbo) {
                $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.DataIscrizioneAlbo = this.dateService.formatDateAsString(new Date(userOrganizationData.alboProfessionale.dataIscrizioneAlbo));
              }
              if (userOrganizationData.alboProfessionale.numeroIscrizioneAlbo) {
                $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.NumeroIscrizioneAlbo = userOrganizationData.alboProfessionale.numeroIscrizioneAlbo;
              }
              if (userOrganizationData.alboProfessionale.provinciaAlbo) {
                $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.ProvinciaAlbo = userOrganizationData.alboProfessionale.provinciaAlbo;
              }
            }

            if (userOrganizationData.rappresentanteFiscaleIncluded) {
              const anagrafica = {} as IAnagrafica;
              anagrafica.Titolo = userOrganizationData.rappresentanteFiscale.titolo;
              anagrafica.CodEORI = userOrganizationData.rappresentanteFiscale.codEORI;
              if (!userOrganizationData.rappresentanteFiscale.denominazione || userOrganizationData.rappresentanteFiscale.denominazione === '') {
                anagrafica.Nome = userOrganizationData.rappresentanteFiscale.nome;
                anagrafica.Cognome = userOrganizationData.rappresentanteFiscale.cognome;
              } else {
                anagrafica.Denominazione = userOrganizationData.rappresentanteFiscale.denominazione;
              }
              $scope.FatturaPA.FatturaElettronicaHeader.RappresentanteFiscale = {
                DatiAnagrafici: {
                  IdFiscaleIVA: {IdCodice: userOrganizationData.PIVA, IdPaese: userOrganizationData.codicePaese},
                  Anagrafica: anagrafica,
                  CodiceFiscale: userOrganizationData.rappresentanteFiscale.fiscalCode
                }
              };
            }


            $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.RegimeFiscale = userOrganizationData.regimeFiscale;
          }, (error) => {
            this.alertService.alert('error', error);
            $rootScope.loading = false;
          });
      };

      $scope.updateModalitaPagamento = () => {
        $scope.FatturaPA.FatturaElettronicaBody[0].DatiPagamento[0].DettaglioPagamento[0].IBAN = '';
        if ($scope.pagamento === '1') {
          $scope.FatturaPA.FatturaElettronicaBody[0].DatiPagamento[0].DettaglioPagamento[0].ModalitaPagamento = 'MP05';
        } else {
          $scope.FatturaPA.FatturaElettronicaBody[0].DatiPagamento[0].DettaglioPagamento[0].ModalitaPagamento = '';
        }
      };
      $scope.aggiungiDescrizione = () => {
        let newItem = jQuery.extend(true, {}, DettaglioLineeItem);
        newItem.NumeroLinea = $scope.FatturaPA.FatturaElettronicaBody[0].DatiBeniServizi.DettaglioLinee.length + 1;
        // @ts-ignore
        $scope.FatturaPA.FatturaElettronicaBody[0].DatiBeniServizi.DettaglioLinee.push(newItem);
      };

      $scope.rimuoviDescrizione = (index) => {
        if ($scope.FatturaPA.FatturaElettronicaBody[0].DatiBeniServizi.DettaglioLinee.length <= 1) {
          this.alertService.alert('warning', 'At least one descrizione is required!');
        } else {
          let modalInstance = $uibModal.open({
            animation: $scope.animationsEnabled,
            component: 'defaultModalComponent',
            windowClass: 'center-modal',
            backdrop: 'static',
            keyboard: false,
            resolve: {
              config: () => {
                return {
                  headerIcon: 'fa fa-exclamation-triangle',
                  headerText: 'Attenzione',
                  bodyHtml: '<i class=\'fa fa-exclamation-triangle\'></i> Sei sicuro di voler cancellare ' + $scope.FatturaPA.FatturaElettronicaBody[0].DatiBeniServizi.DettaglioLinee[index].Descrizione + ' ?',
                  buttons: [
                    {
                      'id': 1,
                      'icon': 'fa fa-ban',
                      'label': 'Annulla'
                    },
                    {
                      'id': 2,
                      'icon': 'fa fa-check-circle-o',
                      'label': 'Si'
                    }
                  ]
                };
              }
            }
          });
          modalInstance.result.then((pressedButtonId) => {
            if (pressedButtonId !== undefined) {
              if (pressedButtonId === 1) {
                // ??
              }
              if (pressedButtonId === 2) {
                // update CIG / CUP
                $scope.resetCIGCUPAfterProductRemove(index, 'DatiOrdineAcquisto');
                $scope.resetCIGCUPAfterProductRemove(index, 'DatiContratto');
                $scope.resetCIGCUPAfterProductRemove(index, 'DatiConvenzione');
                $scope.resetCIGCUPAfterProductRemove(index, 'DatiRicezione');

                $scope.FatturaPA.FatturaElettronicaBody[0].DatiBeniServizi.DettaglioLinee.splice(index, 1);
                for (let i = index; i < $scope.FatturaPA.FatturaElettronicaBody[0].DatiBeniServizi.DettaglioLinee.length; i++) {
                  $scope.FatturaPA.FatturaElettronicaBody[0].DatiBeniServizi.DettaglioLinee[i].NumeroLinea = i + 1;
                }

                $scope.calculateTotal();
                // call autoExpand  to set the correct height for product description
                $timeout(() => {
                  $rootScope.autoExpand('auto-height');
                }, 0);
              }
            }
          }, () => {
            // ?
          });
        }
      };

      $scope.resetCIGCUPAfterProductRemove = (removedIndex, tipoDocumento) => {
        if ($scope.FatturaPA.FatturaElettronicaBody[0].DatiGenerali[tipoDocumento] === undefined) {
          return;
        }

        for (let j = 0; j < $scope.FatturaPA.FatturaElettronicaBody[0].DatiGenerali[tipoDocumento].length; j++) {

          // remove RiferimentoNumeroLinea for deleted NumeroLinea
          let numeroLinea = removedIndex + 1; // we asume NumeroLinea is always Detaglio Linee index + 1
          let position = $scope.FatturaPA.FatturaElettronicaBody[0].DatiGenerali[tipoDocumento][j].RiferimentoNumeroLinea.indexOf(numeroLinea);
          if (position > -1) {
            $scope.FatturaPA.FatturaElettronicaBody[0].DatiGenerali[tipoDocumento][j].RiferimentoNumeroLinea.splice(position, 1);
          }

          // update RiferimentoNumeroLinea for  NumeroLinea > Deleted NumeroLinea
          for (let k = removedIndex + 1; k < $scope.FatturaPA.FatturaElettronicaBody[0].DatiBeniServizi.DettaglioLinee.length; k++) {
            numeroLinea = k + 1; // we asume NumeroLinea is always Detaglio Linee index + 1

            let position = $scope.FatturaPA.FatturaElettronicaBody[0].DatiGenerali[tipoDocumento][j].RiferimentoNumeroLinea.indexOf(numeroLinea);
            if (position > -1) {
              $scope.FatturaPA.FatturaElettronicaBody[0].DatiGenerali[tipoDocumento][j].RiferimentoNumeroLinea[position]--;
            }
          }
        }
      };

      $scope.calculateTotal = () => {
        let TotaleLineeFattura = 0;
        let RitenutaIsOn = ($scope.FatturaPA.FatturaElettronicaBody[0].DatiGenerali.DatiGeneraliDocumento.DatiRitenuta !== undefined &&
          $scope.FatturaPA.FatturaElettronicaBody[0].DatiGenerali.DatiGeneraliDocumento.DatiRitenuta.length > 0);
        let datiCassaPrevidenziale = $scope.FatturaPA.FatturaElettronicaBody[0].DatiGenerali.DatiGeneraliDocumento.DatiCassaPrevidenziale;
        let isEnasarcoImportoContributoCassa = $scope.isEnasarcoSelectedInCassaPrevidenzialeList(datiCassaPrevidenziale);
        let enasarcoImportoContributoCassa = $scope.getEnasarcoSelectedListInCassaPrevidenziale(datiCassaPrevidenziale);
        $scope.hasRitenutaImportoContributoCassa = false;
        $scope.hasRitenutaEnasarcoInCassaPrevidenziale = false;

        for (let i = 0; i < $scope.FatturaPA.FatturaElettronicaBody[0].DatiBeniServizi.DettaglioLinee.length; i++) {
          let qta = $scope.FatturaPA.FatturaElettronicaBody[0].DatiBeniServizi.DettaglioLinee[i].Quantita;
          let pzu = $scope.FatturaPA.FatturaElettronicaBody[0].DatiBeniServizi.DettaglioLinee[i].PrezzoUnitario;
          let scontou = $scope.FatturaPA.FatturaElettronicaBody[0].DatiBeniServizi.DettaglioLinee[i].ScontoMaggiorazione;
          scontou.forEach(s => {
            // console.log(s, pzu);

            if (s.Importo) {
              pzu -= (s.Importo * (s.Tipo === 'SC' ? 1 : -1));
            }
            if (s.Percentuale) {
              pzu *= (1 - (s.Percentuale * (s.Tipo === 'SC' ? 1 : -1)) / 100);
            }
            // console.log(s, pzu);
          });
          // console.log(scontou, pzu);
          let PrezzoTotale = qta * pzu;

          let PrezzoTotaleFormatted = this.numbersService.formatDecimal(PrezzoTotale, 8);
          $scope.FatturaPA.FatturaElettronicaBody[0].DatiBeniServizi.DettaglioLinee[i].PrezzoTotale = PrezzoTotaleFormatted;
          TotaleLineeFattura += PrezzoTotaleFormatted * 1;

          $scope.FatturaPA.FatturaElettronicaBody[0].DatiBeniServizi.DettaglioLinee[i].Ritenuta = RitenutaIsOn ? 'SI' : '';
        }

        $scope.TotaleLineeFattura = this.numbersService.formatDecimal(TotaleLineeFattura * 1, 8);

        //  datiCassaPrevidenziale
        let ImportoContributoCassa = 0;
        for (let i = 0; i < $scope.FatturaPA.FatturaElettronicaBody[0].DatiGenerali.DatiGeneraliDocumento.DatiCassaPrevidenziale.length; i++) {
          let currentDatiCassaPrevidenziale = $scope.FatturaPA.FatturaElettronicaBody[0].DatiGenerali.DatiGeneraliDocumento.DatiCassaPrevidenziale[i];
          // @ts-ignore
          let amountToExtractCassa = $scope.FatturaPA.FatturaElettronicaBody[0].DatiGenerali.DatiGeneraliDocumento.DatiCassaPrevidenziale[i].TipoImponibileImporto === 'TotaleLinee' ? $scope.TotaleLineeFattura : $scope.FatturaPA.FatturaElettronicaBody[0].DatiGenerali.DatiGeneraliDocumento.DatiCassaPrevidenziale[i].ImponibileImporto;
          $scope.FatturaPA.FatturaElettronicaBody[0].DatiGenerali.DatiGeneraliDocumento.DatiCassaPrevidenziale[i].ImponibileCassa = this.numbersService.formatDecimal(amountToExtractCassa, 2);
          let currentImportoContributoCassa = this.numbersService.formatDecimal((amountToExtractCassa * $scope.FatturaPA.FatturaElettronicaBody[0].DatiGenerali.DatiGeneraliDocumento.DatiCassaPrevidenziale[i].AlCassa) / 100, 2);

          $scope.FatturaPA.FatturaElettronicaBody[0].DatiGenerali.DatiGeneraliDocumento.DatiCassaPrevidenziale[i].ImportoContributoCassa = currentImportoContributoCassa;

          if (!$scope.isEnasarcoCassaPrevidenziale(currentDatiCassaPrevidenziale)) {
            ImportoContributoCassa = ImportoContributoCassa + currentImportoContributoCassa * 1;
          }
        }

        // dati Ritenuta
        let ritenutaValTotal = 0;
        if (RitenutaIsOn) {
          for (let i = 0; i < $scope.FatturaPA.FatturaElettronicaBody[0].DatiGenerali.DatiGeneraliDocumento.DatiRitenuta.length; i++) {
            // @ts-ignore
            const aliquotaImporto = $scope.FatturaPA.FatturaElettronicaBody[0].DatiGenerali.DatiGeneraliDocumento.DatiRitenuta[i].AliquotaImporto;
            // @ts-ignore
            let amountToExtractRitenuta = $scope.FatturaPA.FatturaElettronicaBody[0].DatiGenerali.DatiGeneraliDocumento.DatiRitenuta[i].TipoImponibileImporto === 'TotaleLinee'
              // @ts-ignore
              ? $scope.TotaleLineeFattura : $scope.FatturaPA.FatturaElettronicaBody[0].DatiGenerali.DatiGeneraliDocumento.DatiRitenuta[i].ImponibileImporto;
            for (let i = 0; i < $scope.FatturaPA.FatturaElettronicaBody[0].DatiGenerali.DatiGeneraliDocumento.DatiCassaPrevidenziale.length; i++) {
              let currentDatiCassaPrevidenziale = $scope.FatturaPA.FatturaElettronicaBody[0].DatiGenerali.DatiGeneraliDocumento.DatiCassaPrevidenziale[i];
              if (currentDatiCassaPrevidenziale.Ritenuta === 'SI') {
                amountToExtractRitenuta = amountToExtractRitenuta * 1 + currentDatiCassaPrevidenziale.ImportoContributoCassa * 1;
                $scope.hasRitenutaImportoContributoCassa = true;
              }
            }

            let ritenutaVal = this.numbersService.formatDecimal((aliquotaImporto / 100 * amountToExtractRitenuta * $scope.FatturaPA.FatturaElettronicaBody[0].DatiGenerali.DatiGeneraliDocumento.DatiRitenuta[i].AliquotaRitenuta) / 100, 2);

            if ($scope.isEnasarcoSelectedInCassaPrevidenzialeList(datiCassaPrevidenziale)) {
              ritenutaVal = this.numbersService.formatDecimal(1 / 2 * ritenutaVal, 2);
              $scope.hasRitenutaEnasarcoInCassaPrevidenziale = true;
            }

            $scope.FatturaPA.FatturaElettronicaBody[0].DatiGenerali.DatiGeneraliDocumento.DatiRitenuta[i].ImportoRitenuta = ritenutaVal;
            ritenutaValTotal += +ritenutaVal;
          }
        }

        let newDatiRiepilogo = [];
        let ImpostaDatiRiepilogoToShow = [];
        let Imposta = 0;

        for (let i = 0; i < $scope.FatturaPA.FatturaElettronicaBody[0].DatiGenerali.DatiGeneraliDocumento.DatiCassaPrevidenziale.length; i++) {
          let currentDatiCassaPrevidenziale = $scope.FatturaPA.FatturaElettronicaBody[0].DatiGenerali.DatiGeneraliDocumento.DatiCassaPrevidenziale[i];
          let datiCassaPrevidenzialeIndex = i;
          // identify corresponding IVA Item
          let indexes = $.map($scope.ivaItems, (obj, k) => {
            // - come sotto
            // @ts-ignore
            if (obj['data-id'] === currentDatiCassaPrevidenziale.IVA) {
              return k;
            }
          });
          if (indexes.length === 1) {

            let indexesDatiRiepilogo = $.map(newDatiRiepilogo, (obj, j) => {
              if (obj['AliquotaIVA'] === $scope.ivaItems[indexes[0]]['data-value'] &&
                obj['Natura'] === $scope.ivaItems[indexes[0]]['data-natura'] &&
                obj['RiferimentoNormativo'] === $scope.ivaItems[indexes[0]]['data-riferimento']) {
                return j;
              }
            });
            if (indexesDatiRiepilogo.length === 1) {
              newDatiRiepilogo[indexesDatiRiepilogo[0]].ImponibileImporto = this.numbersService.formatDecimal(newDatiRiepilogo[indexesDatiRiepilogo[0]].ImponibileImporto * 1 + currentDatiCassaPrevidenziale.ImportoContributoCassa * 1, 2);
              newDatiRiepilogo[indexesDatiRiepilogo[0]].Imposta = this.numbersService.formatDecimal(newDatiRiepilogo[indexesDatiRiepilogo[0]].Imposta * 1 + ((currentDatiCassaPrevidenziale.ImportoContributoCassa * currentDatiCassaPrevidenziale.AliquotaIVA) / 100), 8);

              if (enasarcoImportoContributoCassa[datiCassaPrevidenzialeIndex] === undefined ||
                enasarcoImportoContributoCassa[datiCassaPrevidenzialeIndex] === 0) {
                if (ImpostaDatiRiepilogoToShow[indexesDatiRiepilogo[0]] !== undefined) {
                  Imposta = ImpostaDatiRiepilogoToShow[indexesDatiRiepilogo[0]];
                }

                Imposta = this.numbersService.formatDecimal(Imposta * 1 + (currentDatiCassaPrevidenziale.ImportoContributoCassa * currentDatiCassaPrevidenziale.AliquotaIVA / 100), 8);
                ImpostaDatiRiepilogoToShow[indexesDatiRiepilogo[0]] = this.numbersService.formatDecimal(Imposta, 8);
              } else {
                Imposta = this.numbersService.formatDecimal(Imposta !== 0.00 ? (Imposta * 1 + currentDatiCassaPrevidenziale.AliquotaIVA / 100) : 0.00, 8);
                ImpostaDatiRiepilogoToShow[indexesDatiRiepilogo[0]] = this.numbersService.formatDecimal(Imposta, 8);
              }
            } else {
              let oneDatiRiepilogo = jQuery.extend(true, {}, DatiRiepilogoItem);
              oneDatiRiepilogo.AliquotaIVA = $scope.ivaItems[indexes[0]]['data-value'];
              oneDatiRiepilogo.Natura = $scope.ivaItems[indexes[0]]['data-natura'];
              oneDatiRiepilogo.RiferimentoNormativo = $scope.ivaItems[indexes[0]]['data-riferimento'];
              oneDatiRiepilogo.ImponibileImporto = this.numbersService.formatDecimal(currentDatiCassaPrevidenziale.ImportoContributoCassa, 2);
              oneDatiRiepilogo.Imposta = this.numbersService.formatDecimal((currentDatiCassaPrevidenziale.ImportoContributoCassa * currentDatiCassaPrevidenziale.AliquotaIVA / 100), 92);

              if (enasarcoImportoContributoCassa[datiCassaPrevidenzialeIndex] !== undefined &&
                enasarcoImportoContributoCassa[datiCassaPrevidenzialeIndex] !== 0) {
                Imposta = this.numbersService.formatDecimal(Imposta * 1, 8);
              } else {
                // @ts-ignore
                Imposta = this.numbersService.formatDecimal(oneDatiRiepilogo.Imposta * 1, 8);
              }

              ImpostaDatiRiepilogoToShow.push(this.numbersService.formatDecimal(Imposta, 8));

              oneDatiRiepilogo.EsigibilitaIVA = oneDatiRiepilogo.Natura.indexOf('N') > -1 ? '' : $scope.EsigibilitaIVA;
              newDatiRiepilogo.push(oneDatiRiepilogo);
            }
          }
        }

        for (let i = 0; i < $scope.FatturaPA.FatturaElettronicaBody[0].DatiBeniServizi.DettaglioLinee.length; i++) {
          let currentDettaglioLinee = $scope.FatturaPA.FatturaElettronicaBody[0].DatiBeniServizi.DettaglioLinee[i];
          // identify corresponding IVA Item
          let indexes = $.map($scope.ivaItems, (obj, k) => {
            // - questo campo esiste sopra, fake field
            // @ts-ignore
            if (obj['data-id'] === currentDettaglioLinee.IVA) {
              return k;
            }
          });
          if (indexes.length === 1) {
            let indexesDatiRiepilogo = $.map(newDatiRiepilogo, (obj, j) => {
              if (obj['AliquotaIVA'] === $scope.ivaItems[indexes[0]]['data-value'] &&
                obj['Natura'] === $scope.ivaItems[indexes[0]]['data-natura'] &&
                obj['RiferimentoNormativo'] === $scope.ivaItems[indexes[0]]['data-riferimento']) {
                return j;
              }
            });
            currentDettaglioLinee.AliquotaIVA = $scope.ivaItems[indexes[0]]['data-value'];
            if (indexesDatiRiepilogo.length === 1) {
              newDatiRiepilogo[indexesDatiRiepilogo[0]].ImponibileImporto = this.numbersService.formatDecimal(newDatiRiepilogo[indexesDatiRiepilogo[0]].ImponibileImporto * 1 + currentDettaglioLinee.PrezzoTotale * 1, 2);
              newDatiRiepilogo[indexesDatiRiepilogo[0]].Imposta = this.numbersService.formatDecimal(newDatiRiepilogo[indexesDatiRiepilogo[0]].Imposta * 1 + ((currentDettaglioLinee.PrezzoTotale * currentDettaglioLinee.AliquotaIVA) / 100), 8);
              Imposta = this.numbersService.formatDecimal(ImpostaDatiRiepilogoToShow[indexesDatiRiepilogo[0]] * 1 + ((currentDettaglioLinee.PrezzoTotale * currentDettaglioLinee.AliquotaIVA) / 100), 8);
              ImpostaDatiRiepilogoToShow[indexesDatiRiepilogo[0]] = this.numbersService.formatDecimal(Imposta, 8);
            } else {
              let oneDatiRiepilogo = jQuery.extend(true, {}, DatiRiepilogoItem);
              oneDatiRiepilogo.AliquotaIVA = $scope.ivaItems[indexes[0]]['data-value'];
              oneDatiRiepilogo.Natura = $scope.ivaItems[indexes[0]]['data-natura'];
              oneDatiRiepilogo.RiferimentoNormativo = $scope.ivaItems[indexes[0]]['data-riferimento'];
              oneDatiRiepilogo.ImponibileImporto = this.numbersService.formatDecimal(currentDettaglioLinee.PrezzoTotale, 2);
              oneDatiRiepilogo.Imposta = this.numbersService.formatDecimal((currentDettaglioLinee.PrezzoTotale * currentDettaglioLinee.AliquotaIVA) / 100, 8);
              Imposta = this.numbersService.formatDecimal(oneDatiRiepilogo.Imposta, 8);
              ImpostaDatiRiepilogoToShow.push(this.numbersService.formatDecimal(Imposta, 8));
              oneDatiRiepilogo.EsigibilitaIVA = oneDatiRiepilogo.Natura.indexOf('N') > -1 ? '' : $scope.EsigibilitaIVA;
              newDatiRiepilogo.push(oneDatiRiepilogo);
            }
          }
        }

        let importoContributoCassaToExtract = 0;

        if (isEnasarcoImportoContributoCassa) {
          enasarcoImportoContributoCassa.forEach((importoEnasarco) => {
            importoContributoCassaToExtract += $scope.TotaleLineeFattura * importoEnasarco.AlCassa / 100;
          });
        }

        importoContributoCassaToExtract = this.numbersService.formatDecimal(importoContributoCassaToExtract, 2);

        $scope.FatturaPA.FatturaElettronicaBody[0].DatiBeniServizi.DatiRiepilogo = newDatiRiepilogo;

        $scope.Imposta = 0;
        ImpostaDatiRiepilogoToShow.forEach((imposta) => {
          $scope.Imposta = $scope.Imposta * 1 + imposta * 1;
        });

        $scope.Imposta = this.numbersService.formatDecimal($scope.Imposta * 1, 2);

        $scope.ImpostaDatiRiepilogoToShow = ImpostaDatiRiepilogoToShow;

        $scope.Imponibile = $scope.TotaleLineeFattura * 1;
        $scope.Imponibile = $scope.Imponibile + ImportoContributoCassa * 1;
        $scope.Imponibile = this.numbersService.formatDecimal($scope.Imponibile, 8);

        $scope.totaleFattura = this.numbersService.formatDecimal($scope.Imponibile * 1 + $scope.Imposta * 1, 2);

        // - ImportoTotaleDocumento must be equals to Imponibile when TD is TD16
        if ($scope.FatturaPA.FatturaElettronicaBody[0].DatiGenerali.DatiGeneraliDocumento.TipoDocumento.includes('TD16')) {
          $scope.FatturaPA.FatturaElettronicaBody[0].DatiGenerali.DatiGeneraliDocumento.ImportoTotaleDocumento = $scope.Imponibile;
        } else {
          $scope.FatturaPA.FatturaElettronicaBody[0].DatiGenerali.DatiGeneraliDocumento.ImportoTotaleDocumento = $scope.totaleFattura;
        }


        let ImportoPagamento = $scope.Imponibile * 1 - ritenutaValTotal * 1;
        ImportoPagamento = ImportoPagamento - importoContributoCassaToExtract * 1;
        ImportoPagamento = this.numbersService.formatDecimal(ImportoPagamento, 2);

        if ($scope.EsigibilitaIVA !== 'S' && !$scope.FatturaPA.FatturaElettronicaBody[0].DatiGenerali.DatiGeneraliDocumento.TipoDocumento.includes('TD16')) {
          ImportoPagamento = this.numbersService.formatDecimal(ImportoPagamento * 1 + $scope.Imposta * 1, 2);
        }

        for (let i = 0; i < $scope.FatturaPA.FatturaElettronicaBody[0].DatiBeniServizi.DatiRiepilogo.length; i++) {
          let impostaVal = $scope.FatturaPA.FatturaElettronicaBody[0].DatiBeniServizi.DatiRiepilogo[i].Imposta;
          $scope.FatturaPA.FatturaElettronicaBody[0].DatiBeniServizi.DatiRiepilogo[i].Imposta = this.numbersService.formatDecimal(impostaVal, 2);
        }

        $scope.FatturaPA.FatturaElettronicaBody[0].DatiPagamento[0].DettaglioPagamento[0].ImportoPagamento = ImportoPagamento;
      };

      $scope.isEnasarcoCassaPrevidenziale = (datiCassaPrevidenziale) => {
        return datiCassaPrevidenziale.TipoCassa === 'TC07';
      };

      $scope.getEnasarcoSelectedListInCassaPrevidenziale = (cassaPrevidenziale) => {
        let enasarco = [];

        cassaPrevidenziale.some((elem, index) => {
          if (elem.TipoCassa === 'TC07') {
            enasarco.splice(index, 0, elem);
          }
        });

        return enasarco;
      };

      $scope.isEnasarcoType = (item) => {
        return item.TipoCassa === 'TC07';
      };

      $scope.isEnasarcoSelectedInCassaPrevidenzialeList = (cassaPrevidenziale) => {
        return cassaPrevidenziale.some((el) => {
          if (el.TipoCassa === 'TC07') {
            return el;
          }
        });
      };

      $scope.selectIva = function (s: any) {
        // identify
        let indexes = $.map($scope.ivaItems, (obj, index) => {
          if (obj['data-id'] === s) {
            return index;
          }
        });
        if (indexes.length === 1) {
          this.item.AliquotaIVA = $scope.ivaItems[indexes[0]]['data-value'];
          this.item.Natura = $scope.ivaItems[indexes[0]]['data-natura'];

          $scope.calculateTotal();
        }
      };

      $scope.readFileCallback = (dropzone, filename, contentBase64) => {
        if (dropzone !== false) {
          // total size of attachment check
          let attachmentSize = contentBase64.length;
          for (let indexFatturaElettronicaBody = 0; indexFatturaElettronicaBody < $scope.FatturaPA.FatturaElettronicaBody.length; indexFatturaElettronicaBody++) {
            if ($scope.FatturaPA.FatturaElettronicaBody[indexFatturaElettronicaBody].Allegati !== undefined) {
              for (let indexAllegati = 0; indexAllegati < $scope.FatturaPA.FatturaElettronicaBody[indexFatturaElettronicaBody].Allegati.length; indexAllegati++) {
                attachmentSize += $scope.FatturaPA.FatturaElettronicaBody[indexFatturaElettronicaBody].Allegati[indexAllegati].Attachment.length;
              }
            }
          }

          if (attachmentSize > $rootScope.fatturaPAAttachmentMaxSize) {
            this.alertService.alert('warning', 'I files allegati superano la dimensione massima accettata (2 MB).');
            return false;
          }
          // end total size of attachment check

          if ($scope.FatturaPA.FatturaElettronicaBody[0].Allegati === undefined) {
            $scope.FatturaPA.FatturaElettronicaBody[0].Allegati = [];
          }

          let newAllegatiItem = jQuery.extend(true, {}, AllegatiItem);
          newAllegatiItem.NomeAttachment = filename;
          newAllegatiItem.FormatoAttachment = filename.split('.').pop();
          newAllegatiItem.Attachment = contentBase64;
          $timeout(() => {
            $scope.FatturaPA.FatturaElettronicaBody[0].Allegati.push(newAllegatiItem);
          });
        }
      };
      $scope.removeAllegati = ($index) => {
        let modalInstance = $uibModal.open({
          animation: $scope.animationsEnabled,
          component: 'defaultModalComponent',
          windowClass: 'center-modal',
          backdrop: 'static',
          keyboard: false,
          resolve: {
            config: () => {
              return {
                headerIcon: 'fa fa-exclamation-triangle',
                headerText: 'Attenzione',
                bodyHtml: '<i class=\'fa fa-exclamation-triangle\'></i> Sei sicuro di voler cancellare allegati ' + $scope.FatturaPA.FatturaElettronicaBody[0].Allegati[$index].NomeAttachment + ' ?',
                buttons: [
                  {
                    'id': 1,
                    'icon': 'fa fa-ban',
                    'label': 'Annulla'
                  },
                  {
                    'id': 2,
                    'icon': 'fa fa-check-circle-o',
                    'label': 'Si'
                  }
                ]
              };
            }
          }
        });
        modalInstance.result.then((pressedButtonId) => {
          if (pressedButtonId !== undefined) {
            if (pressedButtonId === 1) {
              // ??
            }
            if (pressedButtonId === 2) {
              $scope.FatturaPA.FatturaElettronicaBody[0].Allegati.splice($index, 1);
            }
          }
        }, () => {
          // ?
        });
      };

      let formatCIGCUPData = (DatiGenerali) => {
        let formatCIGCUPDataTag = (DatiGenerali, property) => {
          if (DatiGenerali[property] !== undefined) {
            DatiGenerali[property] = $scope.makeSureIsArray(DatiGenerali[property]);
            for (let index = 0; index < DatiGenerali[property].length; index++) {
              if (DatiGenerali[property][index].RiferimentoNumeroLinea !== undefined) {

                // make sure is array: if is only one element , x2js.xml_str2json method create only a string tag
                DatiGenerali[property][index].RiferimentoNumeroLinea = [].concat(DatiGenerali[property][index].RiferimentoNumeroLinea);

                // convert array of string to array of int
                DatiGenerali[property][index].RiferimentoNumeroLinea = DatiGenerali[property][index].RiferimentoNumeroLinea.map((item) => {
                  return parseInt(item, 10);
                });
              } else {
                DatiGenerali[property][index].RiferimentoNumeroLinea = [];
              }
            }
          }
        };

        formatCIGCUPDataTag(DatiGenerali, 'DatiOrdineAcquisto');
        formatCIGCUPDataTag(DatiGenerali, 'DatiContratto');
        formatCIGCUPDataTag(DatiGenerali, 'DatiConvenzione');
        formatCIGCUPDataTag(DatiGenerali, 'DatiRicezione');
      };

      $scope.loadExternalXml = (element) => {
        if (element.files.length === 1) {
          let extension = element.files[0].name.split('.').pop().toLowerCase();
          if (extension !== 'xml') {
            this.alertService.alert('error', 'Only xml files are accpted!');
            return;
          }

          let reader = new FileReader();
          reader.onloadend = () => {
            $scope.loadExistingXml(reader.result);
          };
          reader.readAsText(element.files[0]);
          let $input = $(element);
          let _partial: any = $input.wrap('<form>').closest('form').get(0);
          _partial.reset();
          $input.unwrap();
        }
      };
      $scope.loadExistingXml = (stringXml) => {
        try {
          let fatturaPA: any;
          let parser = new xml2js.Parser({explicitRoot: false, explicitArray: false});

          parser.parseString(stringXml, (err, result) => {
            fatturaPA = result;
          });
          fatturaPA.FatturaElettronicaBody = $scope.makeSureIsArray(fatturaPA.FatturaElettronicaBody);
          for (let i = 0; i < fatturaPA.FatturaElettronicaBody.length; i++) {
            if (fatturaPA.FatturaElettronicaBody[i].DatiGenerali !== undefined) {
              fatturaPA.FatturaElettronicaBody[i].DatiGenerali.DatiGeneraliDocumento.DatiCassaPrevidenziale = $scope.makeSureIsArray(fatturaPA.FatturaElettronicaBody[i].DatiGenerali.DatiGeneraliDocumento.DatiCassaPrevidenziale);
              fatturaPA.FatturaElettronicaBody[i].DatiGenerali.DatiGeneraliDocumento.DatiRitenuta = $scope.makeSureIsArray(fatturaPA.FatturaElettronicaBody[i].DatiGenerali.DatiGeneraliDocumento.DatiRitenuta);
              fatturaPA.FatturaElettronicaBody[i].DatiGenerali.DatiGeneraliDocumento.ScontoMaggiorazione = $scope.makeSureIsArray(fatturaPA.FatturaElettronicaBody[i].DatiGenerali.DatiGeneraliDocumento.ScontoMaggiorazione);
              fatturaPA.FatturaElettronicaBody[i].DatiGenerali.DatiGeneraliDocumento.Causale = $scope.makeSureIsArrayOfObjects(fatturaPA.FatturaElettronicaBody[i].DatiGenerali.DatiGeneraliDocumento.Causale, 'Causale');
              fatturaPA.FatturaElettronicaBody[i].DatiGenerali.DatiGeneraliDocumento.DatiRitenuta = $scope.makeSureIsArray(fatturaPA.FatturaElettronicaBody[i].DatiGenerali.DatiGeneraliDocumento.DatiRitenuta);

              formatCIGCUPData(fatturaPA.FatturaElettronicaBody[i].DatiGenerali);

              if (fatturaPA.FatturaElettronicaBody[i].DatiGenerali.DatiFattureCollegate !== undefined) {
                fatturaPA.FatturaElettronicaBody[i].DatiGenerali.DatiFattureCollegate = $scope.makeSureIsArray(fatturaPA.FatturaElettronicaBody[i].DatiGenerali.DatiFattureCollegate);
                for (let datiFattureCollegateIndex = 0; datiFattureCollegateIndex < fatturaPA.FatturaElettronicaBody[i].DatiGenerali.DatiFattureCollegate.length; datiFattureCollegateIndex++) {
                  if (fatturaPA.FatturaElettronicaBody[i].DatiGenerali.DatiFattureCollegate[datiFattureCollegateIndex].RiferimentoNumeroLinea !== undefined) {
                    fatturaPA.FatturaElettronicaBody[i].DatiGenerali.DatiFattureCollegate[datiFattureCollegateIndex].RiferimentoNumeroLinea = $scope.makeSureIsArrayOfObjects(fatturaPA.FatturaElettronicaBody[i].DatiGenerali.DatiFattureCollegate[datiFattureCollegateIndex].RiferimentoNumeroLinea, 'RiferimentoNumeroLinea');
                  }
                }
              }

              if (fatturaPA.FatturaElettronicaBody[i].DatiGenerali.DatiSAL !== undefined) {
                fatturaPA.FatturaElettronicaBody[i].DatiGenerali.DatiSAL = $scope.makeSureIsArray(fatturaPA.FatturaElettronicaBody[i].DatiGenerali.DatiSAL);
              }

              if (fatturaPA.FatturaElettronicaBody[i].DatiGenerali.DatiDDT !== undefined) {
                fatturaPA.FatturaElettronicaBody[i].DatiGenerali.DatiDDT = $scope.makeSureIsArray(fatturaPA.FatturaElettronicaBody[i].DatiGenerali.DatiDDT);
                for (let datiDDTIndex = 0; datiDDTIndex < fatturaPA.FatturaElettronicaBody[i].DatiGenerali.DatiDDT.length; datiDDTIndex++) {
                  if (fatturaPA.FatturaElettronicaBody[i].DatiGenerali.DatiDDT[datiDDTIndex].RiferimentoNumeroLinea !== undefined) {
                    fatturaPA.FatturaElettronicaBody[i].DatiGenerali.DatiDDT[datiDDTIndex].RiferimentoNumeroLinea = $scope.makeSureIsArrayOfObjects(fatturaPA.FatturaElettronicaBody[i].DatiGenerali.DatiDDT[datiDDTIndex].RiferimentoNumeroLinea, 'RiferimentoNumeroLinea');
                  }
                }
              }
            }

            if (fatturaPA.FatturaElettronicaBody[i].DatiBeniServizi !== undefined) {
              fatturaPA.FatturaElettronicaBody[i].DatiBeniServizi.DatiRiepilogo = $scope.makeSureIsArray(fatturaPA.FatturaElettronicaBody[i].DatiBeniServizi.DatiRiepilogo);
              if (fatturaPA.FatturaElettronicaBody[i].DatiBeniServizi.DettaglioLinee !== undefined) {
                fatturaPA.FatturaElettronicaBody[i].DatiBeniServizi.DettaglioLinee = $scope.makeSureIsArray(fatturaPA.FatturaElettronicaBody[i].DatiBeniServizi.DettaglioLinee);
                for (let dettaglioLineeIndex = 0; dettaglioLineeIndex < fatturaPA.FatturaElettronicaBody[i].DatiBeniServizi.DettaglioLinee.length; dettaglioLineeIndex++) {
                  fatturaPA.FatturaElettronicaBody[i].DatiBeniServizi.DettaglioLinee[dettaglioLineeIndex].CodiceArticolo = $scope.makeSureIsArray(fatturaPA.FatturaElettronicaBody[i].DatiBeniServizi.DettaglioLinee[dettaglioLineeIndex].CodiceArticolo);
                  fatturaPA.FatturaElettronicaBody[i].DatiBeniServizi.DettaglioLinee[dettaglioLineeIndex].ScontoMaggiorazione = $scope.makeSureIsArray(fatturaPA.FatturaElettronicaBody[i].DatiBeniServizi.DettaglioLinee[dettaglioLineeIndex].ScontoMaggiorazione);
                  fatturaPA.FatturaElettronicaBody[i].DatiBeniServizi.DettaglioLinee[dettaglioLineeIndex].AltriDatiGestionali = $scope.makeSureIsArray(fatturaPA.FatturaElettronicaBody[i].DatiBeniServizi.DettaglioLinee[dettaglioLineeIndex].AltriDatiGestionali);
                }
              }
            }

            if (fatturaPA.FatturaElettronicaBody[i].DatiPagamento !== undefined) {
              fatturaPA.FatturaElettronicaBody[i].DatiPagamento = $scope.makeSureIsArray(fatturaPA.FatturaElettronicaBody[i].DatiPagamento);
              for (let datiPagamentoIndex = 0; datiPagamentoIndex < fatturaPA.FatturaElettronicaBody[i].DatiPagamento.length; datiPagamentoIndex++) {
                if (fatturaPA.FatturaElettronicaBody[i].DatiPagamento[datiPagamentoIndex].DettaglioPagamento !== undefined) {
                  fatturaPA.FatturaElettronicaBody[i].DatiPagamento[datiPagamentoIndex].DettaglioPagamento = $scope.makeSureIsArray(fatturaPA.FatturaElettronicaBody[i].DatiPagamento[datiPagamentoIndex].DettaglioPagamento);
                }
              }
            }

            if (fatturaPA.FatturaElettronicaBody[i].Allegati !== undefined) {
              fatturaPA.FatturaElettronicaBody[i].Allegati = $scope.makeSureIsArray(fatturaPA.FatturaElettronicaBody[i].Allegati);
            }
          }

          $scope.FatturaPA.FatturaElettronicaHeader.DatiTrasmissione.CodiceDestinatario = fatturaPA.FatturaElettronicaHeader.DatiTrasmissione.CodiceDestinatario;
          $scope.FatturaPA.FatturaElettronicaHeader.CessionarioCommittente = fatturaPA.FatturaElettronicaHeader.CessionarioCommittente;

          $scope.FatturaPA.FatturaElettronicaBody = fatturaPA.FatturaElettronicaBody;
          // per qualche motivo nel form ng-model di DatiFattureCollegate[0] lo vede come oggetto, non come array e da errore dopo
          $scope.FatturaPA.FatturaElettronicaBody[0].DatiGenerali.DatiFattureCollegate = $scope.FatturaPA.FatturaElettronicaBody[0].DatiGenerali.DatiFattureCollegate || [];
          $scope.pagamento = $scope.FatturaPA.FatturaElettronicaBody[0].DatiPagamento[0].DettaglioPagamento[0].ModalitaPagamento === 'MP05' ? '1' : '2';
          $scope.EsigibilitaIVA = 'S';
          if ($scope.FatturaPA.FatturaElettronicaBody[0].DatiBeniServizi.DatiRiepilogo !== undefined && $scope.FatturaPA.FatturaElettronicaBody[0].DatiBeniServizi.DatiRiepilogo.length > 0) {
            for (let i = 0; i < $scope.FatturaPA.FatturaElettronicaBody[0].DatiBeniServizi.DatiRiepilogo.length; i++) {
              if ($scope.FatturaPA.FatturaElettronicaBody[0].DatiBeniServizi.DatiRiepilogo[i].EsigibilitaIVA) {
                $scope.EsigibilitaIVA = $scope.FatturaPA.FatturaElettronicaBody[0].DatiBeniServizi.DatiRiepilogo[i].EsigibilitaIVA;
                break;
              }
            }
          }

          $scope.calculateTotal();
          // call autoExpand  to set the correct height for product description
          $timeout(() => {
            $rootScope.autoExpand('auto-height');
          }, 0);
        } catch (ex) {
          this.alertService.alert('error', 'We could not load the xml content. Please make sure it contains the correct format !');
        }
      };
      $scope.makeSureIsArray = (possibleObject) => {
        let oldObject = possibleObject;
        possibleObject = [];
        if (oldObject !== null && (typeof oldObject === 'object' || typeof oldObject === 'string')) {
          if (Object.prototype.toString.call(oldObject) === '[object Array]') {
            return oldObject;
          }

          possibleObject.push(oldObject);
        }
        return possibleObject;
      };
      $scope.makeSureIsArrayOfObjects = (possibleObject, objectName) => {
        let oldObject = possibleObject;
        let newObject = [];
        if (oldObject !== null) {
          switch (typeof oldObject) {
            case 'object':
              if (Object.prototype.toString.call(oldObject) === '[object Array]') {
                for (let i = 0; i < oldObject.length; i++) {
                  let item = {};
                  item[objectName] = oldObject[i];
                  newObject.push(item);
                }
                return newObject;
              }
              break;
            case 'string':
              let item = {};
              item[objectName] = oldObject;
              newObject.push(item);
              break;
            default:
              return newObject;
          }
        }
        return newObject;
      };
      let collectData = (json, property) => {
        let new_array = [];
        if (json !== undefined) {
          json.forEach((entry) => {
            let value = entry[property];
            if (value !== undefined && value !== null) {
              new_array.push(value);
            }
          });
        }
        return new_array;
      };

      $scope.updateDateField = (field: string, value: Date) => {
        console.log(field, value);

        if (field === 'DatiGeneraliDocumento.Data') {
          $scope.FatturaPA.FatturaElettronicaBody[0].DatiGenerali.DatiGeneraliDocumento.Data = this.dateService.formatDateAsString(value);
          console.log($scope.FatturaPA.FatturaElettronicaBody[0].DatiGenerali.DatiGeneraliDocumento.Data);

        } else if (field === 'DettaglioPagamento.DataScadenzaPagamento') {
          $scope.FatturaPA.FatturaElettronicaBody[0].DatiPagamento[0].DettaglioPagamento[0].DataScadenzaPagamento = this.dateService.formatDateAsString(value);
        } else if (field === 'DatiFatturaRettificata.DataFR') {
          $scope.FatturaPA.FatturaElettronicaBody[0].DatiGenerali.DatiFatturaRettificata.DataFR = this.dateService.formatDateAsString(value);
        } else if (field === 'DatiFattureCollegate.Data') {
          $scope.FatturaPA.FatturaElettronicaBody[0].DatiGenerali.DatiFattureCollegate[0].Data = this.dateService.formatDateAsString(value);
        }
      };

      $scope.save = () => {
        let fatturaPA = jQuery.extend(true, {}, $scope.FatturaPA);
        // validation
        for (let index = 0; index < fatturaPA.FatturaElettronicaBody.length; index++) {
          if (fatturaPA.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.Anagrafica.Denominazione.length === 0) {
            this.alertService.alert('error', 'Prego selezionare il PA!');
            return;
          }
        }

        // ritenuta has to be set, if we have RItenuta = SI in any DatiCassaPrevidenziale
        let indexesDatiCassaPrevidenzialeWithRitenuta = $.map(fatturaPA.FatturaElettronicaBody[0].DatiGenerali.DatiGeneraliDocumento.DatiCassaPrevidenziale, (obj, k) => {
          if (obj['Ritenuta'] === 'SI') {
            return k;
          }
        });
        if ((indexesDatiCassaPrevidenzialeWithRitenuta.length > 0) &&
          (fatturaPA.FatturaElettronicaBody[0].DatiGenerali.DatiGeneraliDocumento.DatiRitenuta === undefined ||
            fatturaPA.FatturaElettronicaBody[0].DatiGenerali.DatiGeneraliDocumento.DatiRitenuta.length === 0)) {
          this.alertService.alert('error', 'Se hai selezionato \'Ritenuta\' nella sezione \'Cassa Previdenziale\' è necessario compilare la sezione \'Ritenuta d\'acconto\'.');
          return;
        }

        if ($scope.isAutofattura) {
          for (let index = 0; index < fatturaPA.FatturaElettronicaBody[0].DatiBeniServizi.DettaglioLinee.length; index++) {
            let linea = fatturaPA.FatturaElettronicaBody[0].DatiBeniServizi.DettaglioLinee[index];
            if (linea.Natura.indexOf('N6.') >= 0) {
              this.alertService.alert('error', 'Hai specificato una natura esenzione incompatibile con il tipo documento, controlla il dettaglio numero ' + linea.NumeroLinea + ' con descrizione ' + linea.Descrizione);
              return;
            }
          }
        }

        // end validation

        $rootScope.loading = true;

        fatturaPA.FatturaElettronicaBody[0].DatiGenerali.DatiGeneraliDocumento.Divisa = 'EUR';
        fatturaPA.FatturaElettronicaBody.forEach((fatturaElettronicaBody) => {
          if (fatturaElettronicaBody.DatiGenerali !== undefined) {
            // causale
            if (fatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.Causale !== undefined) {
              let datiGeneraliDocumentoCausale = collectData(fatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.Causale, 'Causale');
              fatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.Causale = datiGeneraliDocumentoCausale;
            }

            // datiFattureCollegate
            if (fatturaElettronicaBody.DatiGenerali.DatiFattureCollegate !== undefined) {
              fatturaElettronicaBody.DatiGenerali.DatiFattureCollegate.forEach((datiFattureCollegate) => {
                let datiFattureCollegateRiferimentoNumeroLinea = collectData(datiFattureCollegate.RiferimentoNumeroLinea, 'RiferimentoNumeroLinea');
                datiFattureCollegate.RiferimentoNumeroLinea = datiFattureCollegateRiferimentoNumeroLinea;
              });
            }

            // datiDDT
            if (fatturaElettronicaBody.DatiGenerali.DatiDDT !== undefined) {
              fatturaElettronicaBody.DatiGenerali.DatiDDT.forEach((datiDDT) => {
                let datiDDTRiferimentoNumeroLinea = collectData(datiDDT.RiferimentoNumeroLinea, 'RiferimentoNumeroLinea');
                datiDDT.RiferimentoNumeroLinea = datiDDTRiferimentoNumeroLinea;
              });
            }
          }
        });

        let settings: any = {};
        settings.user = $rootScope.currentUser().sub;
        fatturaPA.FatturaElettronicaHeader.DatiTrasmissione.ProgressivoInvio = '0000000000';
        if ($scope.isAutofattura) {
          // se autofattura swappa cedente e cessionario
          const temp = JSON.parse(JSON.stringify(fatturaPA.FatturaElettronicaHeader.CessionarioCommittente)) as ICedentePrestatore;
          fatturaPA.FatturaElettronicaHeader.CessionarioCommittente = JSON.parse(JSON.stringify(fatturaPA.FatturaElettronicaHeader.CedentePrestatore)) as ICessionarioCommittente;
          fatturaPA.FatturaElettronicaHeader.CedentePrestatore = temp;
          // bisogna anche cambiare il codice destinatario con quello di chi invia
          fatturaPA.FatturaElettronicaHeader.DatiTrasmissione.CodiceDestinatario = 'ACTKBBZ';
          fatturaPA.FatturaElettronicaHeader.DatiTrasmissione.PECDestinatario = (store.get('user') as IUser).accountData.PEC;
        }
        // questo serve se no il modello xml risulta incorretto, il campo del regime fiscale serve solo sul cedente prestatore
        // @ts-ignore
        delete fatturaPA.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.RegimeFiscale;
        // @ts-ignore
        delete fatturaPA.FatturaElettronicaHeader.CessionarioCommittente.IscrizioneREA;
        // @ts-ignore
        delete fatturaPA.FatturaElettronicaHeader.CessionarioCommittente.Contatti;
        // @ts-ignore
        delete fatturaPA.FatturaElettronicaHeader.CessionarioCommittente.RiferimentoAmministrazione;
        // @ts-ignore
        delete fatturaPA.FatturaElettronicaHeader.CedentePrestatore.RappresentanteFiscale;

        let builder1 = new xml2js.Builder(
          {
            renderOpts: {newline: ''},
            headless: true,
            rootName: 'FatturaElettronicaHeader'
          }
        );
        let builder2 = new xml2js.Builder(
          {
            renderOpts: {newline: ''},
            headless: true,
            rootName: 'FatturaElettronicaBody'
          }
        );
        // sembra un foreach a vuoto, serve per il builder xml
        fatturaPA.FatturaElettronicaBody.forEach(element => {
          if (element.Allegati && element.Allegati.length === 0) {
            // @ts-ignore
            element.Allegati.push('');
            // delete element.Allegati;
          }
          if (element.DatiPagamento && element.DatiPagamento.length === 0) {
            // @ts-ignore
            element.DatiPagamento.push('');
            // delete element.DatiPagamento;
          }
          if (element.DatiBeniServizi && element.DatiBeniServizi.DettaglioLinee) {
            element.DatiBeniServizi.DettaglioLinee.forEach(el => {
              if (el.AliquotaIVA) {
                // @ts-ignore
                el.AliquotaIVA = Number(el.AliquotaIVA).toFixed(2);
              }
            });
          }
        });
        let _header = this.addEmptyArray(fatturaPA.FatturaElettronicaHeader);
        let _body = this.addEmptyArray(fatturaPA.FatturaElettronicaBody);
        settings.xml = builder1.buildObject(_header) + builder2.buildObject(_body);
        settings.formatoTrasmissione = fatturaPA.FatturaElettronicaHeader.DatiTrasmissione.FormatoTrasmissione;
        ArchiSmallServices.generateFatturaPA(settings)
          .then((response: any) => {
            if (response.Result === 1) {
              response.uploadType = 1;
              store.set('fatturazionepaComponiFattura-Result', response);
              $rootScope.loading = false;
              $state.go('home.pa-componi-fattura-confirm');
            }
          }, (error) => {
            $rootScope.loading = false;
            this.alertService.alert('error', error.data.errorDetails);
          });
      };

      $scope.FatturaPA = FatturaPA.FatturaPA;
      let oneFatturaElettronicaBodyItem = FatturaElettronicaBodyItem;
      let firstDettaglioLineeItem = jQuery.extend(true, {}, DettaglioLineeItem);
      firstDettaglioLineeItem.NumeroLinea = 1;
      oneFatturaElettronicaBodyItem.DatiBeniServizi.DettaglioLinee.push(firstDettaglioLineeItem);
      let oneDatiPagamentoItem = (jQuery.extend(true, {}, DatiPagamentoItem));
      // @ts-ignore
      oneDatiPagamentoItem.DettaglioPagamento.push(jQuery.extend(true, {}, DettaglioPagamentoItem));
      oneFatturaElettronicaBodyItem.DatiPagamento.push(jQuery.extend(true, {}, oneDatiPagamentoItem));
      // @ts-ignore
      $scope.FatturaPA.FatturaElettronicaBody.push(jQuery.extend(true, {}, oneFatturaElettronicaBodyItem));
      getDataFromUser();
      $scope.pagamento = $scope.FatturaPA.FatturaElettronicaBody[0].DatiPagamento[0].DettaglioPagamento[0].ModalitaPagamento === 'MP05' ? '1' : '2';
      $scope.FatturaPA.FatturaElettronicaBody[0].DatiGenerali.DatiFattureCollegate = [];
      $scope.EsigibilitaIVA = 'S';
      $scope.Imposta = '0.00';
      if ($stateParams.xmlpath !== '') {
        ng.element(document).ready(() => {
          ArchiSmallServices.getFatturaPA($stateParams.xmlpath)
            .then((response: any) => {
              if (response.FatturaPAXML !== undefined) {
                $scope.loadExistingXml(response.FatturaPAXML);
                if ($stateParams.requestNotaCredito) {
                  $scope.FatturaPA.FatturaElettronicaBody[0].DatiGenerali.DatiGeneraliDocumento.TipoDocumento = 'TD04';
                }
              }
            }, (error) => {
              this.alertService.alert('error', error);
            });
        });
      } else {
        $scope.calculateTotal();
      }
      $rootScope.formsubmitted = false;

      $scope.selezionaPAModal = () => {
        let selezionaPAModalInstance = $uibModal.open({
          animation: true,
          component: 'selezionaPAModalComponent',
          size: 'lg',
        });

        selezionaPAModalInstance.result.then((item) => {
          $scope.FatturaPA.FatturaElettronicaHeader.CessionarioCommittente = $scope.getEmptyCessionarioCommittente();

          $scope.FatturaPA.FatturaElettronicaHeader.DatiTrasmissione.CodiceDestinatario = item['cod_uni_ou'];
          $scope.FatturaPA.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.CodiceFiscale = item['cf'];
          $scope.FatturaPA.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.Anagrafica.Denominazione = item['des_amm'].substr(0, 80); // item['cod_amm']+ ' ' + item['des_amm'] + ' ' + item['des_ou'];

          $scope.FatturaPA.FatturaElettronicaHeader.CessionarioCommittente.Sede.Indirizzo = item['indirizzo'];
          $scope.FatturaPA.FatturaElettronicaHeader.CessionarioCommittente.Sede.CAP = item['cap'];
          $scope.FatturaPA.FatturaElettronicaHeader.CessionarioCommittente.Sede.Comune = item['comune'];
          $scope.FatturaPA.FatturaElettronicaHeader.CessionarioCommittente.Sede.Provincia = item['provincia'];
          $scope.FatturaPA.FatturaElettronicaHeader.CessionarioCommittente.Sede.Nazione = 'IT';
        }, () => {
          // ?
        });
      };

      $scope.getEmptyCessionarioCommittente = () => {
        return {
          DatiAnagrafici: {
            IdFiscaleIVA: {},
            CodiceFiscale: '',
            Anagrafica: {
              Denominazione: '',
              Titolo: '',
              CodEORI: ''
            }
          },
          Sede: {
            Indirizzo: '',
            NumeroCivico: '',
            CAP: '',
            Comune: '',
            Provincia: '',
            Nazione: ''
          }
        } as ICessionarioCommittente;
      };

      $scope.openScontoMaggiorazioneModal = (item) => {
        // console.log(item);

        let modalInstance = $uibModal.open({
          animation: true,
          component: 'scontoMaggiorazionePRModalComponent',
          size: 'lg',
          windowClass: 'center-modal',
          backdrop: 'static',
          keyboard: false,
          resolve: {
            settings: () => {
              return {
                scontoMaggiorazione: item.ScontoMaggiorazione
              };
            }
          }
        });
        modalInstance.result.then((ScontoMaggiorazione) => {
          if (ScontoMaggiorazione !== undefined) {
            item.ScontoMaggiorazione = ScontoMaggiorazione;
          }
          $scope.calculateTotal();
        });
      };

      $scope.CigCupModal = () => {
        let CigCupModalInstance = $uibModal.open({
          animation: true,
          component: 'cigCupModalComponent',
          size: 'lg',
          windowClass: 'center-modal',
          backdrop: 'static',
          keyboard: false,
          resolve: {
            settings: () => {
              return {
                datiGenerali: $scope.FatturaPA.FatturaElettronicaBody[0].DatiGenerali,
                dettaglioLinee: $scope.FatturaPA.FatturaElettronicaBody[0].DatiBeniServizi.DettaglioLinee,
              };
            }
          }
        });
        CigCupModalInstance.result.then((DatiGenerali) => {
          if (DatiGenerali !== undefined) {
            $scope.FatturaPA.FatturaElettronicaBody[0].DatiGenerali.DatiOrdineAcquisto = DatiGenerali.DatiOrdineAcquisto;
            $scope.FatturaPA.FatturaElettronicaBody[0].DatiGenerali.DatiContratto = DatiGenerali.DatiContratto;
            $scope.FatturaPA.FatturaElettronicaBody[0].DatiGenerali.DatiConvenzione = DatiGenerali.DatiConvenzione;
            $scope.FatturaPA.FatturaElettronicaBody[0].DatiGenerali.DatiRicezione = DatiGenerali.DatiRicezione;
          }
        }, () => {
          // ?
        });
      };

      $scope.cassaPrevidenzialeModal = () => {
        let cassaPrevidenzialeModalInstance = $uibModal.open({
          animation: true,
          component: 'cassaPrevidenzialeModalComponent',
          size: 'lg',
          windowClass: 'center-modal',
          backdrop: 'static',
          keyboard: false,
          resolve: {
            items: () => {
              return $scope.FatturaPA.FatturaElettronicaBody[0].DatiGenerali.DatiGeneraliDocumento.DatiCassaPrevidenziale.slice();
            }
          }
        });
        cassaPrevidenzialeModalInstance.result.then((items) => {
          if (items !== undefined) {
            $scope.FatturaPA.FatturaElettronicaBody[0].DatiGenerali.DatiGeneraliDocumento.DatiCassaPrevidenziale = items;
            $scope.calculateTotal();
          }
        }, () => {
          // ?
        });
      };

      $scope.ritenutaAccontoModal = () => {
        let ritenutaAccontoModalInstance = $uibModal.open({
          animation: true,
          component: 'ritenutaAccontoPAModalComponent',
          size: 'lg',
          windowClass: 'center-modal',
          backdrop: 'static',
          keyboard: false,
          resolve: {
            items: () => {
              return $scope.FatturaPA.FatturaElettronicaBody[0].DatiGenerali.DatiGeneraliDocumento.DatiRitenuta;
            }
          }
        });
        ritenutaAccontoModalInstance.result.then((items) => {
          if (items !== undefined) {
            if (items.length === 0) {
              $scope.FatturaPA.FatturaElettronicaBody[0].DatiGenerali.DatiGeneraliDocumento.DatiRitenuta = [];
            } else {
              $scope.FatturaPA.FatturaElettronicaBody[0].DatiGenerali.DatiGeneraliDocumento.DatiRitenuta = items;
              $scope.EsigibilitaIVA = 'I';
            }
            $scope.calculateTotal();
          }
        }, () => {
          // ?
        });
      };

      $scope.bolloVirtualeModal = () => {
        let bolloVirtualeModalInstance = $uibModal.open({
          animation: true,
          component: 'bolloVirtualePAModalComponent',
          size: 'lg',
          windowClass: 'center-modal',
          backdrop: 'static',
          keyboard: false,
          resolve: {
            item: () => {
              return $scope.FatturaPA.FatturaElettronicaBody[0].DatiGenerali.DatiGeneraliDocumento.DatiBollo === undefined ? '' : $scope.FatturaPA.FatturaElettronicaBody[0].DatiGenerali.DatiGeneraliDocumento.DatiBollo.BolloVirtuale;
            }
          }
        });
        bolloVirtualeModalInstance.result.then((item) => {
          if (item) {
            // @ts-ignore
            $scope.FatturaPA.FatturaElettronicaBody[0].DatiGenerali.DatiGeneraliDocumento.DatiBollo = (jQuery.extend(true, {}, DatiBolloItem));
            $scope.FatturaPA.FatturaElettronicaBody[0].DatiGenerali.DatiGeneraliDocumento.DatiBollo.BolloVirtuale = 'SI';
            $scope.FatturaPA.FatturaElettronicaBody[0].DatiGenerali.DatiGeneraliDocumento.DatiBollo.ImportoBollo = this.numbersService.formatDecimal(2, 2);
          } else {
            $scope.FatturaPA.FatturaElettronicaBody[0].DatiGenerali.DatiGeneraliDocumento.DatiBollo = undefined;
          }
        }, () => {
          // ?
        });
      };

      $scope.dpOpened = {
        DatiGeneraliDocumentoData: false,
        DataScadenzaPagamento: false
      };
      $scope.openDP = ($event, opened) => {
        $event.preventDefault();
        $event.stopPropagation();
        $scope.dpOpened[opened] = true;
      };
      $scope.autoOpen = ($event, opened) => {

        if (appContext.userBrowser['isIE']) {
          return;
        }
        $event.preventDefault();
        $event.stopPropagation();
        $scope.dpOpened[opened] = true;
      };

      $scope.tipoDocumentoChanged = () => {
        const tipoDocumento = $scope.FatturaPA.FatturaElettronicaBody[0].DatiGenerali.DatiGeneraliDocumento.TipoDocumento;

        const fatturaWithDatiFattureCollegate = ['TD16', 'TD17', 'TD18', 'TD19', 'TD28', 'TD29'];
        $scope.isAutofattura = fatturaWithDatiFattureCollegate.includes(tipoDocumento);

        if ($scope.FatturaPA.FatturaElettronicaBody[0].DatiGenerali.DatiFatturaRettificata) {
          $scope.FatturaPA.FatturaElettronicaBody[0].DatiGenerali.DatiFatturaRettificata = undefined;
        }
        $scope.calculateTotal();
      };
    }

    $onInit(): void {
      this.logoService.getImagePreview()
        .then((result: any) => {
          this.imagePreview = result.data;
        }, (error: any) => {
          this.imagePreview = '';
        });
    }

    public addEmptyArray(val: any) {
      if (Array.isArray(val)) {
        if (val.length === 0) {
          return [''];
        }
        return val.reduce((res, cur) => {
          if (cur !== '') {
            return [...res, this.addEmptyArray(cur)];
          }
          return res;
        }, []);
      } else if (Object.prototype.toString.call(val) === '[object Object]') {
        return Object.keys(val).reduce((res, key) => {
          if (val[key] !== '') {
            return Object.assign({}, res, {[key]: this.addEmptyArray(val[key])});
          }
          return res;
        }, {});
      }
      return val;
    }
  }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/fatturazione-pa/pa-componi-fattura-semplice/pa-componi-fattura-semplice.ts